module.exports = __webpack_public_path__ + "static/media/jquery.88022797.png";